<template>
  <p
    class="
      flex
      justify-center
      items-center
      py-0.5
      px-2
      text-sm
      font-medium
      bg-black bg-opacity-50
      text-white
      absolute
      bottom-1
      right-1
      text-shadow
      rounded-full
      z-5
      gap-x-2
    "
  >
    {{ displayName === 'Monitor' ? 'Diagnostic Imaging' : displayName }}
    <!-- Microphone -->
    <ViceMicrophone v-if="!isExternalDevice" class="h-5 w-5" :muted="isMutedMicrophone" />

    <!-- Stats -->
    <ViceStats
      :statsValue="localStats"
      v-if="!hideStats && !isMultiCameraStream && !isExternalDevice"
    />

    <!-- Raise Hand -->
    <RaisedHandIcon v-if="raisedHand" />

    <!-- Stream controls -->
    <StreamOptions
      v-if="isMultiCameraStream"
      :showSwitchDevice="true"
      :showDisconnectDevice="true"
      :streamName="displayName"
      :hidePreview="!shouldShowRemoteUserVideoOff"
      :isAudioMuted="isAudioMuted"
      :externalAudioIO="externalAudioIO"
      @disconnectDevice="$emit('disconnectDevice')"
      @changeCameraSource="$emit('changeCameraSource')"
      @togglePreviewOverlay="$emit('togglePreviewOverlay')"
      @toggleVuzixAudio="$emit('toggleVuzixAudio')"
      @toggleExternalAudioIO="$emit('toggleExternalAudioIO')"
    />
  </p>
</template>

<script>
import ViceStats from '@/Components/Stats/ViceStats.vue';
import RaisedHandIcon from '@/Components/Icons/RaisedHandIcon.vue';
import ViceMicrophone from '@/Components/Icons/ViceMicrophone.vue';
import StreamOptions from '@/Components/Session/Grid/StreamOptions.vue';

export default {
  props: {
    localStats: {
      type: Number,
      required: false,
      default: 0,
    },
    hideStats: {
      type: Boolean,
      default: false,
    },
    isMutedMicrophone: {
      type: Boolean,
    },
    isAudioMuted: {
      type: Boolean,
    },
    shouldShowRemoteUserVideoOff: {
      type: Boolean,
    },
    toggleMultiCamera: {
      type: Function,
    },
    disconnectMultiCamera: {
      type: Function,
    },
    isMultiCameraStream: {
      type: Boolean,
    },
    isExternalDevice: {
      type: Boolean,
      default: false,
    },
    displayName: {
      type: String,
      required: true,
    },
    raisedHand: {
      type: Boolean,
      default: false,
    },
    externalAudioIO: {
      default: true,
    },
  },
  emits: [
    'togglePreviewOverlay',
    'disconnectDevice',
    'changeCameraSource',
    'toggleVuzixAudio',
    'toggleExternalAudioIO',
  ],
  components: {
    StreamOptions,
    ViceStats,
    RaisedHandIcon,
    ViceMicrophone,
  },
};
</script>
